import { LocaleCode } from '~/models/locale/types'

export const marketGuideAdvices: Record<
  LocaleCode,
  { title: string; body: string }[]
> = {
  el: [
    {
      title: 'Μην δίνετε προκαταβολή αν δεν έχετε δει το όχημα',
      body: `
        <p>
          <b>ΜΗ ΣΤΕΛΝΕΤΕ ΠΡΟΚΑΤΑΒΟΛΕΣ</b> Μην επηρεάζεστε από την καλή τιμή. Μη στείλετε προκαταβολή σε αγγελίες που
          δουλεύουν με email ή αγγελίες εξωτερικού. <br>
          Ειδικότερα, μη στείλετε προκαταβολή
        </p>
        <p>
          <b>ΣΕ ΑΓΓΕΛΙΕΣ ΠΟΥ ΕΧΟΥΝ EMAIL ΜΕΣΑ ΣΤΙΣ ΦΩΤΟΓΡΑΦΙΕΣ Ή ΣΤΗΝ ΠΕΡΙΓΡΑΦΗ</b><br>
          <b>Θα χάσετε τα λεφτά σας</b>. <br>
        </p>
        <p>
          Αν έχετε κάποιο πρόβλημα από αγγελίες ιδιωτών ή εμπόρων, ή αν δείτε κάποια ψεύτικη αγγελία σας παρακαλούμε να
          μας ειδοποιήσετε άμεσα στο info@car.gr ή να κάνετε παρατήρηση πάνω στην αγγελία. Σε κάθε αγγελία, κάτω από το
          πεδίο της φωτογραφίας, <b>μπορείτε να κάνετε παρατήρηση</b> (αν π.χ. κάποια αγγελία είναι ψεύτικη ή
          παραπλανητική ή λάθος κλπ). Έτσι βοηθάτε όλοι σας να υπάρχουν "σωστές" αγγελίες.
        </p>
        <p>
          <b>Εάν το όχημα βρίσκεται στην Ελλάδα</b> είναι προτιμότερο να πάτε οι ίδιοι να το πληρώσετε και να το
          πάρετε αμέσως, αφού πάρετε και τα σχετικά έγγραφα.<br>
          Μη στέλνετε χρήματα χωρίς να δείτε τον πωλητή και να πάρετε το όχημα, είναι σχεδόν σίγουρο ότι θα τα χάσετε.
          Να ζητάτε 1) πάντα σταθερό τηλέφωνο πωλητή και 2) ακόμη ποιό σίγουρα είναι να σας στείλει ο πωλητής υπεύθυνη
          δήλωση του νόμου 105 υπογεγραμμένη από ΚΕΠ ότι θα πάρει την προκαταβολή για το συγκεκριμένο εμπόρευμα. Πολλοί
          απατεώνες βρίσκουν διάφορες δικαιολογίες (π.χ. σας λένε ότι έχουν κάποια "μεγάλη" θέση π.χ. στο δημόσιο, ή
          ότι θα χάσετε την ευκαιρία το θέλουν πολλοί, ή ότι έχουν ανάγκη κλπ.) για να σας ξεγελάσουν. Σας δίνουν ακόμη
          κανονικό όνομα και πραγματικό αριθμό λογαριασμού σε ελληνική τράπεζα και δεν δέχονται να συναντηθείτε. Δεν
          τους νοιάζει γιατί παίρνουν τα χρήματα π.χ. με κάρτα.<br>
          Απατεώνες γράφουν συχνά ότι βρίσκονται πολύ μακριά π.χ σε νησί για να μην μπορέσετε να πάτε εύκολα. Ενα τρίκ
          για να μπορέσετε να τσεκάρετε τον πωλητή είναι να του πείτε ότι ενδιαφέρεστε άμεσα για το όχημα και επειδή
          είστε πολύ μακριά αν θέλει να του στείλετε προκαταβολή. Αν είναι τίμιος θα σας πει ότι δεν θέλει προκαταβολή
          και είναι πιο σωστό να πάτε να το δείτε πρώτα.
        </p>
        <p>
          <b>Εάν το όχημα βρίσκεται στο εξωτερικό </b>
          είναι προτιμότερο να "κλείσετε" το αυτοκίνητο με συμβόλαιο ιδιωτικό που θα στείλετε μέσω Φάξ και μετά να
          ταξιδέψετε για να το πληρώσετε και κανονίσετε μόνοι σας την μεταφορά του παίρνοντας τον τίτλο κυριότητας.<br>
          Όταν πληρώσετε το όχημα καλό είναι να δείτε την ταυτότητα του πωλητή και να βγάλετε και μια φωτοτυπία. <br>
          Εαν πρόκειται<b> για ανταλλακτικά</b> είναι προτιμότερο να πάτε ο ίδιος να τα πληρώσετε και να τα πάρετε ή
          να σας στείλει ο πωλητής το εμπόρευμα με αντικαταβολή, έτσι ώστε να πληρώνετε το εμπόρευμα κατά την παραλαβή
          του. Έτσι είναι σίγουρο ότι θα σταλεί και δεν θα χάσετε τα χρήματά σας.<b>Αν βάλετε αγγελία Ζήτησης</b>.<br>
          Αν βάλατε αγγελία ζήτησης και σας πάρουν να σας πούν ότι έχουν το συγκεκριμένο που ζητάτε καλύτερα να πάτε να
          το παραλάβετε ο ίδιος. Αν σας ζητήσουν προκαταβολή μη στείλετε.<br>
          Αν στείλετε να ζητάτε 1) πάντα σταθερό τηλέφωνο πωλητή και 2) ακόμη ποιό σίγουρα είναι να σας στείλει ο
          πωλητής υπεύθυνη δήλωση του νόμου 105 υπογεγραμμένη από ΚΕΠ ότι θα πάρει την προκαταβολή για το συγκεκριμένο
          εμπόρευμα.
        </p>`
    },
    {
      title:
        'Απατεώνες στέλνουν ψεύτικα καταθετήρια. Μη στείλετε τίποτα αν δεν δείτε τα χρήματα στον λογαριασμό σας',
      body: `
        <p>
            Σας λένε ότι έχουν καταθέσει τα χρήματα, σας δείχνουν ένα <b>ψεύτικο καταθετήριο</b> που το έχουν
            παραποιήσει αλλά φαίνεται σαν αυθεντικό. Έρχονται καλοντυμένοι, ευγενικοί κλπ. Λένε ότι τα χρήματα έχουν
            μεταφερθεί αλλά επειδή π.χ. είναι από άλλη τράπεζα θα αργήσουν να φανούν στο λογαριασμό σας και ότι
            βιάζονται να πάρουν το όχημα (ή άλλες δικαιολογίες). Εσείς τους πιστεύετε και κάνετε την μεταβίβαση.
            <b>Μετά είναι αργά.</b><br>
            <b>Μη στείλετε τίποτα αν δεν δείτε τα χρήματα να είναι στον λογαριασμό σας και δεν επιβεβαιώσει η τράπεζα
            ότι είναι διαθέσιμα.</b>
        </p>`
    },
    {
      title:
        'Προσοχή στις αγγελίες με στοιχεία επικοινωνίας στην φωτό ή στο κείμενο',
      body: `
        <p>
          <b> E-mail στις φωτογραφίες ή μέσα στο κείμενο των αγγελιών βάζουν απατεώνες!!! Προσοχή θα χάσετε τα λεφτά
          σας.</b><br>Όσες αγγελίες έχουν email ή τηλέφωνο στην <b> ΦΩΤΟΓΡΑΦΙΑ ή ΠΕΡΙΓΡΑΦΗ </b> είναι πάρα πολύ
          επικίνδυνες και είναι σχεδόν βέβαιο ότι αποσκοπούν στην εξαπάτησή σας! Μην δίνετε προκαταβολή βασιζόμενοι
          σε επαφή μόνο με email η μόνο με κινητό. <b> ΝΑ ΖΗΤΑΤΕ ΠΑΝΤΑ ΚΑΙ ΣΤΑΘΕΡΟ ΤΗΛΕΦΩΝΟ </b> πρίν ξεκινήσετε να
          πάτε να δείτε ένα όχημα. Αν ο πωλητής δεν θέλει να δώσει σταθερό να προσέξετε πολύ. Σας υπόσχονται να σας
          στείλουν το αμάξι με μια ΜΕΤΑΦΟΡΙΚΗ εταιρεία, η οποία είναι πλαστή.
        </p>
        <p>
          Φτιάχνουν ακόμη και ψεύτικη ιστοσελίδα της μεταφορικής για να σας ξεγελάσουν. Χρησιμοποιούν πολλές φορές
          ελληνικά τηλέφωνα, που όμως είναι π.χ. FAX κάποιας τυχαίας εταιρείας, λάθος νούμερα, τηλέφωνα στα οποία δεν
          απαντά κανείς κλπ., για να σας κάνουν να πιστέψετε ότι το τηλέφωνο είναι ελληνικό και αληθινό και ότι δήθεν
          βρίσκονται προς το παρόν στο εξωτερικό. Να μην εμπιστεύεστε πωλητές που βάζουν ψεύτικα τηλέφωνα και δουλεύουν
          μόνο με e-mail. Το αυτοκίνητο δεν θα το παραλάβετε ποτέ!! Προσοχή στα Ε-MAIL και στα ΚΙΝΗΤΑ πωλητών που το
          αυτοκίνητο έχει δελεαστικές τιμές αλλά βρίσκεται δήθεν στο ΕΞΩΤΕΡΙΚΟ!!!
        </p>
        <p>
          Τεχνικά είναι δυνατόν να γίνει και παραποίηση των e-mail με αποτέλεσμα να φαίνεται σαν αποστολέας κάποιος που
          δεν έχει σχέση με αυτό το e-mail. Μη στέλνετε προσωπικά δεδομένα μέσω e-mail και προπάντων δεδομένα που
          σχετίζονται με πιστωτικές κάρτες.
        </p>`
    },
    {
      title: 'Προσοχή στις συναλλαγές με western union, paypal, επιταγές κλπ',
      body: `
        <p>
          <b>Προσοχή στις επιταγές! Από το εξωτερικό είναι στις περισσότερες περιπτώσεις ακάλυπτες - (Για το
          εσωτερικό: Μην πουλάτε το αμάξι με επιταγές είναι πολύ επικίνδυνο)!!! </b>
        </p>
        <p>
          Όταν καταθέτετε, στην τράπεζα, μία επιταγή από εξωτερικό για να πάρετε τα χρήματά σας πρέπει να περάσει εώς
          και ένας μήνας και συνήθως διαπιστώνετε απλά ότι είναι ψεύτικη/ακάλυπτη. Αρα δεν παίρνετε χρήματα και έχετε
          στα χέρια σας απλά ένα άχρηστο χαρτί.<b> Ένα κόλπο για να σας ξεγελάσουν είναι ότι δεν κάνουν καθόλου
          παζάρια</b> (κάνουν τους οικονομικά άνετους, μετά σας στέλνουν μια επιταγή με μεγαλύτερο ποσό από αυτό που
          συμφωνήσανε (τάχα κατά λάθος) και ζητάνε από εσάς να τους στείλετε τα ρέστα πίσω. Σας λένε ότι έκαναν λάθος
          το ποσό και σας πιέζουν με συνεχή τηλεφωνήματα για να δώσετε πίσω την διαφορά.<br>
          Στην ουσία θέλουν να σας πάρουν την διαφορά και μετά εξαφανίζονται. Μην τους τα δίνετε πίσω.
        </p>
        <p>
          <b>Σας ζητάνε πολλές φορές τον αριθμό λογαριασμού σας</b> βάζουν στην τράπεζά σας μια επιταγή (η οποία είναι
          ακάλυπτη) η οποία είναι το ποσό του αυτοκινήτου π.χ. 4000 ευρώ + π.χ. 1000 ευρώ για την μεταφορά. Φαίνεται
          στον λογαριασμό σας ότι τάχα μπήκαν τα χρήματα των 5000 ευρώ (είναι όμως θεωρητικά στον λογαριασμό σας δεν
          μπορείτε να τα πάρετε στο χέρι, πρέπει να τα πάρει πρώτα η τράπεζα σας από την τράπεζα του εξωτερικού). Μετά
          σας παίρνει η δήθεν μεταφορική εταιρεία τηλέφωνο και σας ζητάει να της στείλετε τα 1000 ευρώ μέσω π.χ.
          Western Union. Εσείς βάζετε τα 1000 ευρώ, που τάχα σας έβαλε ο αγοραστής παραπάνω για την μεταφορά, και τα
          χάνετε. Γιατί μέσα σε ένα μήνα το πολύ η τράπεζα σας παίρνει πίσω τα 5000 ευρώ, λόγω του ότι η επιταγή ήταν
          ακάλυπτη. <b>Μην δίνετε τα στοιχεία του λογαριασμού σας </b>σε ενδιαφερόμενους που υπόσχονται να σας βάλουν
          χρήματα από το εξωτερικό, μερικές φορές και παραπάνω από αυτά που ζητάτε γιατί δήθεν έχουν αγοραστή και
          θέλουν προμήθεια! Αποσκοπούν στην <b>εξαπάτησή</b> σας.
        </p>
        <p>
            Μεγάλη προσοχή στις συναλλαγές σας με τις τράπεζες <b> WESTERN UNION</b>, την <b>Escrow</b> και την
            <b>MoneyGram</b> ή άλλες τράπεζες που δουλεύουν με ανάλογο τρόπο. Συνήθως άτομα από το εξωτερικό σας κάνουν
            δελεαστικές προσφορές και αποσκοπούν στην <b>εξαπάτησή</b> σας. Σας υπόσχονται δήθεν εγγυητική μεταχείριση
            της τράπεζας. Μόνο το νούμερο συναλλαγής χρειάζεται κανείς για την παραλαβή χρημάτων από τέτοιες τράπεζες,
            το όνομα δεν παίζει ρόλο και έτσι δεν γνωρίζετε στην ουσία σε ποιον στέλνετε τα χρήματά σας! Τις
            περισσότερες φορές η παραλαβή των χρημάτων γίνεται με πλαστή ταυτότητα.
        </p>`
    },
    {
      title:
        'Μην πραγματοποιήσετε αγορά αν δεν έχετε ελέγξει την κυριότητα του οχήματος',
      body: `
        <p>
          <b>Προσοχή στον τίτλο ιδιοκτησίας του οχήματος</b> (και πιο πολύ από το εξωτερικό) <b>ανήκει πράγματι στον
          πωλητή</b>; είναι πραγματικά το διαφημιζόμενο όχημα? Μάθετε την πινακίδα του οχήματος και ρωτήστε σε κάποια
          αντιπροσωπεία ή σε κάποια ασφάλεια για το ιστορικό του οχήματος (χρονολογία, χιλιόμετρα, σέρβις, ιδιοκτήτης,
          τρακάρισμα κλπ.). Καλό επίσης είναι να γίνεται πριν απο την αγορά τεχνικός έλεγχος του οχήματος για τυχόν
          τρακαρίσματα/μηχανικές βλάβες/τήρηση εγγύησης κλπ.<b>Να ελέγχετε την χρονολογία του οχήματος και τον αριθμό
          σασί</b>. Συνηθίζεται από τους πωλητές να "βαπτίζουν" το όχημά τους νεώτερο από ότι είναι. Να το ελέγχετε
          πρίν ξεκινήσετε να δείτε το όχημα. Να ελέγχετε αν ο αριθμός που είναι "χτυπημένος" στο σασί είναι ο ίδιος με
          αυτόν της άδειας κυκλοφορίας.<b> Αν αγοράζετε αυτοκίνητο καλό είναι να έχετε κάποιον μαζί σας</b> π.χ.
          μηχανικό που θα καταλάβει αν το αμάξι έχει πρόβλημα ή είναι τρακαρισμένο. Να ζητάτε να σας βεβαιώνεται
          γραπτώς ότι είναι ατρακάριστο, πόσα χιλιόμετρα έχει και την ακριβή χρονολογία για να είσαστε και "νομικά"
          καλυμμένοι.
        </p>
        <p>
          <b>Προσοχή σε πωλητές που πουλάνε προσημειωμένο αυτοκίνητο</b> (που σημαίνει ότι χρωστάνε δόσεις και δεν
          έχουν την πλήρη ιδιοκτησία του αυτοκινήτου). Να διαβάζετε πρώτα την άδεια αν γράφει παρακράτηση. Σε τέτοια
          περίπτωση μη δίνετε προκαταβολή και μην πληρώνετε το χρέος του παλαιού ιδιοκτήτη δήθεν με την εγγύηση
          υπεύθυνης δήλωσης ή ιδιωτικού συμφωνητικού. Αν μετά την πληρωμή σας δεν θέλει να μεταβιβάσει το αυτοκίνητο θα
          μπλέξετε σε δικαστήρια και ίσως δεν πρόκειται να πάρετε ποτέ τον τίτλο κυριότητάς του. Μπορείτε να ζητήσετε
          στην τράπεζα αναδοχή χρέους και όταν εγκριθεί θα μεταβιβαστεί το αυτοκίνητο στο όνομά σας. Ρωτήστε στην
          τράπεζα για περαιτέρω πληροφορίες.
        </p>`
    },
    {
      title:
        'Προσοχή στις συναλλαγές με αγοραστές και οχήματα από το εξωτερικό',
      body: `
        <p>
          <b>Προσοχή στα SMS που στέλνουν απατεώνες</b> από το εξωτερικό που θέλουν δήθεν να αγοράσουν το όχημά σας
          χωρίς παζάρια και χωρίς να το δουν, θέλοντας να πληρώσουν μέσω PAYPAL. <b>Μην απαντάτε σε SMS</b> ιδιαίτερα
          αν έχει στο κείμενο e-mail. Αν ενδιαφέρεται πραγματικά κάποιος θα σας πάρει τηλέφωνο. Μην πέφτετε στην<b>
          παγίδα ανταλλαγής e-mail</b>. Απατεώνες δημιουργούν ένα <b>PAYPAL</b> λογαριασμό με μια πιστωτική κάρτα. Μετά
          σας στέλνουν τα χρήματα για το αυτοκίνητο και μόλις πάρουν το αυτοκίνητο λένε στην τράπεζα της πιστωτικής
          κάρτας να κάνουν ακύρωση της πληρωμής. <b> Σκοπός τους είναι να σας πάρουν τα έξοδα μεταφοράς δηλ. τα 800 εως
          2000 ευρώ</b> που σας τα έχουν τάχα προκαταβάλει και τα οποία πρέπει να τα πληρώσετε εσείς κατευθείαν στη
          μεταφορική εταιρεία. Τα χρήματα αυτά, της μεταφοράς, αν τα στείλετε θα τα χάσετε. <b>Σας απειλούν μάλιστα ότι
          θα σας κάνουν μήνυση</b>. Αν δεν μπουν τα λεφτά στην τσέπη σας, αν δεν εισπράξετε δηλ. τα χρήματα,
          μην πιστεύετε τίποτα και κανέναν.
        </p>
        <p>
          <b>Διαβάστε παρακάτω τη μαρτυρία ενός μέλους μας </b><br>
          "Κάποια στιγμή στην ημέρα δέχτηκα ένα sms μέσω κάποιου site αποστολής sms(hok.bik) ότι κάποιος έχει δει την
          αγγελία μου στο car.gr και σε περίπτωση που δεν το έχω πουλήσει να του στείλω e-mail για πρόσθετες
          πληροφορίες. Το μήνυμα ήταν στα αγγλικά και το όνομα ξένο.<br>
          Μετά από κάποιες λίγες ερωτήσεις που μου έκανε για την κατάσταση του αυτοκινήτου, και κάποια παζάρια, μου
          ανέφερε ότι θέλει να το αγοράσει.<br>
          Αφού τον ρώτησα πως θα γίνει αυτό αν αυτός είναι στο εξωτερικό, αυτός μου απάντησε ότι τώρα βρίσκεται στις
          Βερμούδες και θα γίνει η μεταφορά από κάποιον άλλο και να μην με απασχολεί οποιαδήποτε διαδικασία και έξοδο
          μεταφοράς καθώς θα το καλύψει αυτός.<br>
          Μετά με ρώτησε εάν έχω λογαριασμό Paypal για να μου βάλει τα λεφτά εκεί. Του απάντησα ναι και του έδωσα τον
          αριθμό. Μέσα σε λίγα λεπτά είχα e-mail από Paypal ότι μου κατατέθηκαν τα λεφτά του αυτοκινήτου συν 800 ευρώ
          για την εταιρεία μεταφοράς. Μάλιστα στο e-mail έλεγε ότι επειδή το ποσό κατάθεσης είναι μεγάλο, και
          προκειμένου να εξασφαλιστεί ο αγοραστής ότι θα πάρει το αυτοκίνητο θα έπρεπε εγώ να καταθέσω τα λεφτά
          μεταφοράς σε έναν λογαριασμό Western Union στην Αγγλία και μετά θα μπορούσα να εισπράξω τα λεφτά της
          κατάθεσης.<br>
          Επειδή είμαι λίγο πιο προχωρημένος χρήστης Η/Υ διαπίστωσα ότι το e-mail του Paypal ήταν καλά καμουφλαρισμένο
          και στην πραγματικότητα είχε σταλεί από μια άλλη διεύθυνση Gmail. Δηλαδή απάτη..<br>
          Μάλιστα στο e-mail ανέφερε ότι σε περίπτωση που έχω την οποιαδήποτε απορία μπορώ να κάνω reply και ενώ θα
          φαινότανε ότι κάνω στο paypal, στην πραγματικότητα θα έκανα πάλι σε αυτόν. Θα έπαιρνε δηλαδή κάποιος τα 800
          ευρώ μέσω Western Union και μετά καπνός. Έκανα προώθηση στο paypal το μήνυμα ως ύποπτο και με ενημέρωσαν πως
          όντως είναι απάτη.Δεν είχαν μπει στο λογαριασμό μου χρήματα και ουδέποτε το paypal ζήτησε να γίνει κατάθεση
           απο εμένα στην Western Union."
        </p>`
    },
    {
      title:
        'Να είστε πάντα συνοδηγός κατά την δοκιμαστική οδήγηση του οχήματος σας',
      body: `
        <p>
          <b>Αν ΠΟΥΛΑΤΕ το όχημά σας ΠΡΟΣΟΧΗ!! Κατά τη δοκιμαστική οδήγηση του οχήματος σας να συνταξιδεύετε και
          εσείς</b>. Καλό είναι κατά την πώληση να μην είσαστε μόνοι σας. Μην αφήνετε τον υποψήφιο αγοραστή να οδηγήσει
          μόνος του το όχημα που πουλάτε και προπάντων μην του δίνετε τα χαρτιά του οχήματος. Μπορεί να το πάρει και να
          φύγει.<b><br>
          Αν σας πάρουν με απόκρυψη</b> και θέλουν να δούνε το όχημά σας, να ζητάτε το νούμερο του τηλεφώνου τους. Μην
          εμπιστεύεστε αγοραστές που παίρνουν με απόκρυψη. Αν έρθουν σπίτι σας σημειώστε το νούμερο του αυτοκινήτου
          τους. Μη στείλετε με φάξ ή email την άδεια του οχήματος σε άγνωστους.
        </p>
        <p>
          Αν σας ζητήσει ο αγοραστής να του πάτε εσείς σε αυτόν το όχημα που έχετε προς πώληση ΜΗΝ ΤΟ ΚΑΝΕΤΕ.
          <ul>
            <li>Θα σας πεί διάφορα για να σας κατεβάσει την τιμή που συμφωνήσατε</li>
            <li>Αν δεν το πάρει θα έχετε κάνει τόσο κόπο χωρίς λόγο</li>
            <li>Μην ετοιμάζετε χαρτιά πριν την αγορά να του δώσετε. Μπορεί να σας πάρει τα χαρτιά του αυτοκινήτου, το
            τιμολόγιο και το όχημα και να απαιτήσει νόμιμα πλέον ότι έχετε γράψει στα χαρτιά</li>
          </ul>
        </p>`
    },
    {
      title: 'Συμβουλές για ασφαλείς αγορές',
      body: `
        <p>
          <strong> Η πληρωμή είναι καλύτερα να γίνει μέσα σε μια τράπεζα</strong> ώστε να μην έχετε μαζί σας χρήματα.
          Είναι πολύ πιο σίγουρο να γίνει κατευθείαν μεταφορά από τον λογαριασμό σας στον λογαριασμό του, αφού έχετε
          δει πριν την ταυτότητά του και τον τίτλο κυριότητας του οχήματος.
        </p>
        <p>
          <b>Προτιμήστε δηλωμένους εμπόρους, με κατάστημα στην Ελλάδα</b>, ώστε αργότερα αν έχετε κάποιο πρόβλημα να
          τους ξαναβρείτε στην έδρα τους.  Σας αντιμετωπίζουν με υπευθυνότητα και σας παρέχουν εγγύηση και
          χρηματοδότηση.
        </p>
        <p>
          <b>Το Car.gr δεν έχει καμία σχέση με την πράξη πώλησης αυτοκινήτου</b>, δεν γνωρίζει ούτε τον αγοραστή ούτε
          τον πωλητή και ούτε μπορεί να εγγυηθεί για την αξιοπιστία τους και ούτε γνωρίζει ποιός απο ποιόν αγόρασε
          κάποιο όχημα. Η διαδικασία αγοροπωλησίας γίνεται μόνο μεταξύ αγοραστή και πωλητή.<br>
          Σας γνωστοποιούμε ακόμη ότι το Car.gr αποστέλλει e-mail σε πωλητές ή αγοραστές οχημάτων (σχετικά με
          δημοσιευμένες αγγελίες στο Car.gr) μόνο αν έχετε εσείς κάποιο ερώτημα. Δεν σας ζητάει ποτέ κωδικούς. <b>Σε
          περίπτωση αμφιβολίας ζητήστε τη γνώμη κάποιου ειδικού ή στείλτε μας e-mail στο info@car.gr, ή τηλεφωνήστε
          μας.</b>
        </p>`
    },
    {
      title:
        'Προτιμάτε την άμεση μεταβίβαση οχήματος και όχι την Εξουσιοδότηση!',
      body: `
        <p>
          Σε κάθε αγοραπωλησία ακολουθείστε τη νόμιμη διαδικασία μεταβίβασης του οχήματος. Μη δέχεστε να
          εξουσιοδοτήσετε τον αγοραστή του οχήματος να κάνει μόνος του τη μεταβίβαση, γιατί πολύ συχνά δεν γίνεται στον
          ίδιο αλλά σε κάποιον άλλο, άγνωστο σε εσάς. Μέχρι να ολοκληρωθεί η διαδικασία της μεταβίβασης, αποκλειστικά
          υπεύθυνος τόσο φορολογικά όσο και νομικά είστε εσείς ως κάτοχος του οχήματος.
        </p>`
    }
  ],
  en: [
    {
      title: "Do not pay a deposit if you haven't seen the vehicle.\n",
      body: `
        <p>
          <b>Do not send deposits</b> Do not be influenced by the good price. Do not send a deposit to ads that work
          with email or foreign ads. <br>
          More specifically, do not send a deposit
        </p>
        <p>
          <b>In ads that have email in the photos or in the description.</b><br>
          <b>You will lose your money.</b>
        </p>
        <p>
          If you have any problems with private or merchant ads, or if you see any fake ads, please notify us
          immediately at info@car.gr or report and make a comment on the ad. In every ad, below the photo field, you
          can make a comment (e.g. if some ad is fake, misleading, or wrong, etc.). This way, you all help to have
          "correct" ads.
        </p>
        <p>
          <b>If the vehicle is in Greece</b> it is preferable for you to go and pay for it yourselves and buy it
          immediately, after you receive the relevant documents.<br>
          Do not send money without seeing the seller or getting the vehicle; it is almost certain that you will lose
          it. Always ask for 1) the seller's landline phone and 2) even more securely, ask the seller to send you a
          responsible declaration of Law 105 signed by CRA stating that he will receive the deposit for this
          specific item. Many scammers find various excuses (e.g. they tell you they have a "high” position, e.g.
          in the public sector, or that you will lose a good opportunity, or that they really need it, etc.) to
          deceive you. They even give you a real name and real bank account number in a Greek bank and refuse to
          meet you. They don't care how they get the money, e.g. with a card.<br>
          Scammers often write that they are very far away, e.g. on an island, so you can't easily go. One trick to
          be able to check the seller is to tell him that you are interested immediately in the vehicle and because
          you are very far away if he wants you to send him a deposit. If he is honest, he will tell you that he does
          not want a deposit and it is more correct for you to go see the vehicle first.
        </p>
        <p>
          <b>If the vehicle is abroad</b>
          it is better to "book" the car with a private contract that you will send via fax and then travel to pay for it
          and arrange its transport yourself by taking the ownership title. <br>
          When you pay for the vehicle, it is good to see the seller's ID and make a photocopy.
          If it is a <b>spare part</b>, it is better to go and pay for it yourself and collect it or have the seller send you the goods
          on delivery, so that you pay for the goods on collection. That way you are sure it will be shipped and you won't lose your money.
          <b>If you place a Wanted ad</b>. <br>
          If you placed a Wanted ad and someone contacts you claiming to have the specific item you are looking for, it
          is better to go and pick it up yourself. If they ask you for a deposit, do not send it.<br>
          If you do send, always ask for 1) the seller's landline phone number and 2) it is even more secure for the
          seller to send you a responsible affidavit of Law 105 signed by CRA stating that he will receive the deposit
          for the specific merchandise.
        </p>`
    },
    {
      title:
        'Scammers send fake deposits. Do not send anything if you don’t see the money in your account.',
      body: `
        <p>
          They tell you that they have deposited the money, show you a <b>fake deposit slip</b> that has been forged
          but looks authentic. They come well-dressed, polite, etc. They say that the money has been transferred, but
          because, for example, it is from another bank, it will take time to appear in your account, and that they are
          in a hurry to get the vehicle (or other excuses). You believe them and make the transfer. <b>Then it's too
          late </b><br>
          <b>Do not send anything if you don’t see the money in your account and the bank confirms it is available.</b>
        </p>`
    },
    {
      title: 'Beware of ads with contact details in the photo or text',
      body: `
        <p>
          <b>Scammers put emails in the photos or in the text of the ads!!! Attention you will lose your money.</b><br>
          All ads with email or phone in the <b>PHOTO or DESCRIPTION</b>are very dangerous and almost certainly aim to
          deceive you! Do not give a deposit based on based on email-only or mobile-only contact. <b>ALWAYS ASK FOR A
          LANDLINE</b> before you go to see a vehicle. If the seller does not want to provide a landline, be very
          careful. They promise to send you the car with a TRANSPORT company, which is fake.
        </p>
        <p>
          They even create a fake website for the shipping company to trick you. They often use Greek phone numbers,
          which are actually, for example, a FAX of a random company, wrong numbers, phone numbers that no one answers,
          etc., to make you believe that the phone is Greek and real or that supposedly they are currently abroad. Do
          not trust sellers who use fake phone numbers and only work with email. You will never receive the car!! Be
          careful with the EMAILS and CALLS of sellers who have tempting prices for the car but supposedly are abroad!!!
        </p>
        <p>
          Technically, it is possible to forge emails, resulting in someone who has nothing to do with this email
          appearing as the sender. Do not send personal data via email and especially don’t send data related to
          credit cards.
        </p>`
    },
    {
      title:
        'Be careful with transactions involving Western Union, PayPal, checks, etc.',
      body: `
        <p>
          <b>Be careful with checks! From abroad, they are mostly uncovered - (For domestic (within the country)
          transactions: Do not sell your car with checks; it is very dangerous)!!!</b>
        </p>
        <p>
          When you deposit a check from abroad at the bank to get your money, it may take up to a month, and usually,
          you simply find out that it is fake/uncovered. So, you don't get any money, and you simply have a useless
          piece of paper in your hands.
        </p>
        <p>
          <b>A trick to fool you is that they don't bargain at all.</b> They act financially comfortable, then they
          send you a check for a larger amount than agreed (supposedly by mistake) and ask you to send them back the
          difference. They tell you that they made a mistake with the amount and pressure you with constant phone calls
          to return the difference.<br>
          In essence, they want to take the difference from you and then disappear. Don’t give it back to them.
        </p>
        <p>
          <b>They often ask for your account number</b> and deposit a check into your bank account (which is uncovered),
          which includes the amount of the car, for example, 4000 euros + for example, 1000 euros for transportation.
          It appears in your account that supposedly 5000 euros have been deposited (but theoretically, you cannot
          physically withdraw them from your account, your bank must first receive them from the foreign bank). Then,
          the supposed transportation company calls you and asks you to send them the 1000 euros via, for example,
          Western Union. You put in the 1000 euros, supposedly added by the buyer for transportation, and you lose
          them. Because within a month at most, your bank takes back the 5000 euros, as the check was uncovered. <b>
          Don’t give out your account details </b> to interested parties who promise to deposit money from abroad,
          sometimes even more than what you ask for because allegedly they have a buyer and want a commission! <b>They
          aim to defraud you.</b>
        </p>
        <p>
          Exercise extreme caution in your transactions with WESTERN UNION, Escrow, MoneyGram, or other banks that
          operate similarly. Individuals from abroad often make enticing offers to you and aim to deceive you. They
          falsely promise you the bank's supposed guarantee. Only the transaction number is needed to receive money
          from such banks; the name does not matter, so essentially you do not know who you are sending your money
          to! Most of the time, the money is collected using fake identification.
        </p>`
    },
    {
      title:
        'Do not make a purchase if you have not checked the ownership of the vehicle',
      body: `
        <p>
          <b>Pay attention to the vehicle's ownership title</b> (especially from abroad)) <b>does it really belong to
          the seller</b>? Is the advertised vehicle real? Find out the license plate of the vehicle and ask at a
          dealership or insurance company about its history (date, mileage, service, owner, accidents, etc.). It is
          also good to have a pre-purchase technical inspection of the vehicle for any crashes/mechanical
          damages/warranty maintenance, etc.<b>
        </p>
        <p>
          <b>Check the vehicle's age and chassis number</b>. Sellers often 'rebrand' their vehicles as newer than they
          are. Verify this before you go to see the vehicle. Check if the chassis number matches the registration
          document. <b>If you are buying a car, it is good to have someone with you</b> such as a mechanic, who will
          understand if the car has a problem or has been damaged. Ask for a written assurance that it is
          accident-free, how many kilometers it has, and the exact date so you are also legally covered.
        </p>
        <p>
          <b>Beware of sellers who sell a prepaid car</b> (meaning they owe installments and do not have full ownership
          of the car). First, read the license if it states retention. In such cases, do not pay any deposit and do not
          pay the debt of the previous owner supposedly with the guarantee of a responsible declaration or private
          agreement. If after your payment they refuse to transfer the car, you will get involved in legal disputes and
          may never receive the ownership title. You can request debt assumption at the bank, and when approved, the
          car will be transferred to your name. Ask the bank for further information.
        </p>`
    },
    {
      title: 'Caution to transactions with buyers and vehicles from abroad.',
      body: `
        <p>
          <b>Beware of SMS sent by scammers</b>  from abroad who allegedly want to buy your vehicle without bargaining
          and without seeing it, wanting to pay via PAYPAL. <b>Do not respond to SMS messages</b>, especially if the
          text contains an email. If someone is genuinely interested, they will call you. Do not fall into the trap of
          exchanging emails. Scammers create a <b>PAYPAL</b> account with a credit card. Then they send you money for the car,
          and as soon as they receive the car, they tell the bank of the credit card to cancel the payment. <b>Their
          goal is to get you to cover the shipping costs</b>, i.e., the 800 to 2000 euros that they supposedly pre-paid
          you, and which you must pay directly to the shipping company. If you send the money for shipping, you will
          lose it. <b>They even threaten to sue you</b>. If the money does not enter your pocket, if you do not receive
          the money, do not believe anything or anyone.
        </p>
        <p>
          <b>Read below the testimony of one of our members: </b><br>
          "At some point during the day, I received an SMS through some sms sending site(hok.bik) stating that someone
          had seen my ad on car.gr and in case I hadn't sold it, I can send an email for additional information.
          The message was in English and the name was foreign.<br>
          After a few questions he asked me about the condition of the car, and some bargaining, he told me he wanted
          to buy it.<br>
          After asking him how this would happen if he was abroad, he replied that he was now in Bermuda and the
          transfer would be made by someone else, and I shouldn't worry about any procedure and expenses for
          transportation as he would cover that.<br>
          Then he asked me if I had a PayPal account to transfer the money there. I answered yes and gave him the
          number. Within a few minutes, I had an email from PayPal that the money for the car plus 800 euros for the
          shipping company had been deposited into my account. In fact, the email said that because the deposit amount
          was large, and in order to ensure that the buyer would receive the car, I should deposit the shipping money
          into a Western Union account in England and then I could collect the deposit money.<br>
          Because I am a slightly more advanced computer user, I found that the PayPal email was well camouflaged and
          in reality, it had been sent from another Gmail address. In other words, it was a scam.<br>
          The email also stated that in case I had any questions, I could reply, and while it would appear that I was
          replying to PayPal, in reality, I would be replying to him again. Someone would receive the 800 euros via
          Western Union, and then disappear. I forwarded the message to paypal as suspicious and they informed me that
          it was indeed a scam. No money had been deposited into my account, and PayPal never asked me to make a
          deposit to Western Union.”
        </p>`
    },
    {
      title: 'Always be a passenger during the test drive of your vehicle',
      body: `
        <p>
          <b>If you are SELLING your vehicle, CAUTION!! During the test drive of your vehicle, travel with them as
          well</b>. It is advisable that you are not alone during the sale. Don't let the potential buyer drive your
          vehicle alone, and above all, don't give them the vehicle papers. They might take it and leave.<br>
          <b>If they call you with concealment</b> and want to see your vehicle, ask for their phone number. Don't
          trust buyers who call concealed. If they come to your house, note down the license plate number of their
          car. Do not send the vehicle's license via fax or email to strangers.
        </p>
        <p>
          If the buyer asks you to go to them with the vehicle you have for sale, DO NOT DO IT.
          <ul>
            <li>They will tell you various things to lower the price you agreed upon.</li>
            <li>If they don't buy it, you will have made all that effort for no reason.</li>
            <li>Don't prepare pre-purchase paperwork to give him. They might take the vehicle papers, the invoice,
            the vehicle and legally demand everything you have written on the papers.</li>
          </ul>
        </p>`
    },
    {
      title: 'Tips for safe purchases',
      body: `
        <p>
          <strong>It is best to pay inside a bank</strong> so that you don’t have cash with you. It is much safer to
          make a direct transfer from your account to theirs, after you have seen their ID and the vehicle ownership
          title beforehand.
        </p>
        <p>
          <b>Prefer registered dealers, with a store in Greece</b>, so that later if you have any problem, you can
          find them back at their headquarters. They treat you responsibly and provide you with warranty and financing.
        </p>
        <p>
          <b>Car.gr has nothing to do with the sale of a car</b>, it does not know the buyer or the seller, and it
          cannot guarantee their reliability, nor does it know who bought a vehicle from whom. The buying and selling
          process takes place only between the buyer and the seller.<br>
          Furthermore, we inform you that Car.gr sends emails to vehicle sellers or buyers (related to published ads
          on Car.gr) only if you have a question. It never asks for passwords.<b> In case of doubt, seek the opinion
          of an expert or email us at info@car.gr, or call us.</b>
        </p>`
    },
    {
      title: 'Prefer direct transfer of the vehicle and not authorization!',
      body: `
        <p>
          In any purchase and sale, follow the legal procedure for transferring the vehicle. Do not accept authorizing
          the buyer to transfer the vehicle on their own, because often it is not done by them but by someone else,
          unknown to you. Until the transfer process is completed, you are solely responsible, both legally and
          tax-wise, as the owner of the vehicle.
        </p>`
    }
  ]
}
